/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Phone_RequiredInputs */

const vi_error_shop_phone_required = /** @type {(inputs: Error_Shop_Phone_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cần xác minh số điện thoại trước khi đặt đơn.`)
};

/**

* @param {Error_Shop_Phone_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_phone_required = /** @type {((inputs?: Error_Shop_Phone_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Phone_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_phone_required(inputs)
});